import React from "react";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slides = [
  { id: "1", image: "assets/images/keindia/slide1.png" },
  { id: "2", image: "assets/images/keindia/slide2.png" },
  { id: "3", image: "assets/images/keindia/slide3.png" },
  { id: "4", image: "assets/images/keindia/slide4.png" },
  { id: "5", image: "assets/images/keindia/slide5.png" },
  { id: "6", image: "assets/images/keindia/slide6.png" },
  { id: "7", image: "assets/images/keindia/slide7.png" },
];

export const SectionSeven = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const sliderSettings = {
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  };

  return (
    <div className="section-seven-Ind">
      <div className="container-fluid">
        <div className="heading-Ind" style={{ textAlign: 'center', maxWidth: "1151px" }}>
          <h1 className="suite-title-Ind" style={{ color: "black", fontWeight: "400" }}>
            Engage Shoppers Across Channels with{" "}
            <span style={{ color: "#2400FF" }}>Personalized Journeys</span> that Convert
          </h1>
        </div>

        <div className="d-flex justify-content-center">
          <div style={{ width: '100%', maxWidth: '900px', padding: '0 10px' }}>
            <Slider {...sliderSettings}>
              {Slides.map((slide) => (
                <div key={slide.id}>
                  <img
                    src={slide.image}
                    alt={`Banner${slide.id}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",     // or "contain" if you want full visibility
                      maxHeight: "650px"  
                    }}
                    className="slide-ban-image"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>

        <div className="quote1">
          <img src="assets/images/keindia/quote.png" alt="" style={{ width: "72px", height: "63px" }} />
          <h4 className="quotes1" style={{ maxWidth: "1114px", textAlign: isMobile ? "left" : "center" }}>
            KwikEngage along with KwikPass enabled us to scale retention marketing revenue to upwards of 1 Cr monthly at a profitable ROI for the brand. The data network of GoKwik is truly a differentiator.
          </h4>
          <p className="owner">Jayanth R , D2C Head, Bombay Shaving Company</p>
          <img
            style={{ marginTop: "15px", width: "76px", height: "60px" }}
            src="assets/images/keindia/bscblack.png"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};
